import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, PropType, ref } from 'vue';
import VueI18n from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'expansion-panel',
  props: {
  title: {
    type: String as PropType<string | VueI18n.TranslateResult>,
    required: true,
  },
  isFullColor: {
    type: Boolean,
    default: false,
  },
  // Whether to show the dropdown panel bar or not
  showDropdown: {
    type: Boolean,
    default: true,
  },
  showDropdownExpanded: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const IconArrow = defineAsyncComponent(() => import('@white-label-icon/icon-arrow'));



const isExpanded = ref(props.showDropdownExpanded);

const expand = ():void => {
  isExpanded.value = !isExpanded.value;
};

const handleBodyClick = ():void => {
  if (props.isFullColor) {
    expand();
  }
};


return { __sfc: true,IconArrow, props, isExpanded, expand, handleBodyClick }
}

})